import { useState } from "react";

import { TableAccessModal } from "@/components/common/modals/table-access-modal";

import {
  ContextMenuItem,
  ContextMenuSeparator
} from "@/components/ui/context-menu";

import BackgroundColorPicker from "./background-color-picker";
import Relations from "./inner-text";
import TextColorPicker from "./text-color-picker";
import BorderColorPicker from "./border-picker";

interface Props extends React.ComponentProps<"div"> {
  rightClickedElement: HTMLElement;
}

/**
 * Keeps button access and styling in one menu entry.
 */
const ButtonContextActions: React.FC<Props> = ({ rightClickedElement }) => {
  const [isAccessModalOpen, setIsAccessModalOpen] = useState(false);

  const accessTarget =
    (rightClickedElement.closest(
      '[contenteditable="false"]'
    ) as HTMLElement | null) ?? rightClickedElement;
  const elementId = accessTarget?.id ?? "";

  const removeButton = () => {
    const buttonWrapper = rightClickedElement.closest(
      '[contenteditable="false"]'
    ) as HTMLElement | null;

    const targetElement = buttonWrapper || rightClickedElement;
    const trailing = targetElement.nextSibling;

    targetElement.remove();

    if (trailing && trailing.nodeName === "BR" && trailing.parentElement) {
      trailing.parentElement.removeChild(trailing);
    }
  };

  return (
    <>
      <ContextMenuItem
        className="flex items-center justify-between"
        onSelect={(event) => {
          event.preventDefault();
          if (!accessTarget) return;
          setIsAccessModalOpen(true);
        }}
      >
        دسترسی
      </ContextMenuItem>
      <Relations rightClickedElement={rightClickedElement} />
      <BackgroundColorPicker rightClickedElement={rightClickedElement} />
      <BorderColorPicker rightClickedElement={rightClickedElement} />
      <TextColorPicker rightClickedElement={rightClickedElement} />
      <ContextMenuSeparator />
      <ContextMenuItem className="text-red-500" onClick={removeButton}>
        حذف دکمه
      </ContextMenuItem>

      <TableAccessModal
        isOpen={isAccessModalOpen}
        tableId={elementId}
        table={accessTarget}
        title="مدیریت دسترسی دکمه"
        showColumns={false}
        onClose={() => setIsAccessModalOpen(false)}
      />
    </>
  );
};
export default ButtonContextActions;
